// Chrome (and other Chromium browsers) only offer the "save password" prompt when it observes a
// traditional form submission that navigates. Our auth flows are SPA forms: they preventDefault, hit
// the API and client-navigate, so that heuristic never fires and credentials are never offered for
// saving. The Credential Management API lets us ask the browser to store the credential explicitly —
// it surfaces the same native save prompt. Call this right after a successful login.
//
// Feature-detected and best-effort: unsupported browsers (e.g. Firefox lacks PasswordCredential) and
// non-secure contexts simply no-op, and any rejection is swallowed since saving is never critical.
export async function saveCredential(email: string, password: string): Promise<void> {
  if (!email || !password) return
  if (typeof window === 'undefined') return
  if (!('credentials' in navigator) || !('PasswordCredential' in window)) return
  try {
    // PasswordCredential isn't in the default TS lib DOM types.
    const Ctor = (
      window as unknown as { PasswordCredential: new (data: { id: string; password: string }) => Credential }
    ).PasswordCredential
    const credential = new Ctor({ id: email, password })
    await navigator.credentials.store(credential)
  } catch {
    // Saving credentials is best-effort; never let it break the login flow.
  }
}
